import { gql } from '@apollo/client';
import { useMutation } from '@apollo/client/react';

const ONBOARDING_SUBMIT_SYNAPSE_VALIDATION_STEP = gql`
    mutation OnboardingSubmitSynapseValidationStep($candidateUuid: ID!) {
        onboardingSubmitSynapseValidationStep(candidateUuid: $candidateUuid) {
            uuid
            step
        }
    }
`;

const useOnboardingSubmitSynapseValidationStep = () => {
    const [mutate, { loading, error }] = useMutation(ONBOARDING_SUBMIT_SYNAPSE_VALIDATION_STEP);

    const submitSynapseValidationStep = async (candidateUuid) => {
        return mutate({
            variables: { candidateUuid },
        });
    };

    return {
        submitSynapseValidationStep,
        loading,
        error,
    };
};

export default useOnboardingSubmitSynapseValidationStep;
